import { styled } from '@mui/material';

/**
 * Text that only assistive technology reads. Visible to a screen reader, absent from the
 * visual layout — for the label a sighted user gets from an icon or position alone, and for
 * `role="status"` announcements whose visual counterpart is a spinner or a skeleton.
 *
 * Not `display: none` and not `visibility: hidden`: both remove the node from the
 * accessibility tree as well, which is the opposite of the point. The 1px-clip recipe keeps
 * it rendered and announced. `whiteSpace: nowrap` stops a long string wrapping inside the
 * 1px box, which some screen readers read as separate lines.
 */
const VisuallyHidden = styled('span')({
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
  border: 0,
});

export default VisuallyHidden;
